import {
	API,
	Card,
	Input,
	Submit,
	Table,
	ViewHeader,
	useSubmit,
} from '@enkla-gui';
import React, { useEffect, useState } from 'react';

import { icons } from '@config';
import { notify } from '@/_helpers';

export default function Users() {
	const [invites, setInvites] = useState(false);
	const [users, setUsers] = useState(false);
	const [currentUser, setCurrentUser] = useState(null);
	const {
		register,
		error,
		loading,
		getValues,
		submit: sendInvite,
	} = useSubmit({
		endpoint: 'api/invites',
		success: (res) => {
			notify.toast('Inbjudan skickad');
			getInvites();
		},
	});

	useEffect(() => {
		getUsers();
		getInvites();
		API.get('api/auth/me').then(setCurrentUser);
	}, []);

	const getInvites = () => {
		API.get('api/invites').then((invites) => {
			setInvites(invites);
		});
	};
	const getUsers = () => {
		API.get('api/users').then((users) => {
			setUsers(users);
		});
	};
	const removeUser = (user) => {
		if (user.billable_admin === 1)
			return notify.toast('Du kan inte ta bort en administratör');
		API.delete(`api/auth/user/${user.id}`).then(() => {
			getUsers();
		}).catch(([error, res]) => {
			notify.toast(res.message, 'error')
		});
	};

	const resetMfa = async (user) => {
		if (!user.mfa_enabled) return;
		if (
			!(await notify.confirm(
				`Återställ MFA för ${user.name}? Användaren kan därefter logga in med endast lösenord.`,
			))
		)
			return;
		API.post(`api/users/${user.id}/mfa/reset`)
			.then((res) => {
				notify.toast(res.message || 'MFA har återställts');
				getUsers();
			})
			.catch(([, res]) => {
				notify.toast(res.message, 'error');
			});
	};
	const removeInvite = async (invite) => {
		if (!(await notify.confirm(`Är du säker på att du vill ta bort inbjudan?`)))
			return;
		API.delete(`api/invites/${invite.id}`).then(() => {
			getInvites();
		}).catch(([error, res]) => {
			notify.toast(res.message, 'error')
		});
	};

	const onSubmit = async (data) => {
		if (
			!(await notify.confirm(
				`Är du säker på att du vill bjuda in ${getValues('email')}?`,
			))
		)
			return;
		sendInvite();
	};

	return (
		<>
			<ViewHeader
				icon="fa-briefcase"
				title="Inställningar"
				subtitle="Användare"
			/>

			<Card title="Användare" icon="fas fa-user">
				<Table
					rows={users}
					keys={[
						'name',
						'email',
						'_this>function:admin',
						'_this>function:mfa',
						'_this>function:resetMfa',
						`_this>button:remove:${icons.remove}`,
					]}
					functions={{
						remove: (user) => removeUser(user),
						admin: (user) =>
							user.billable_admin === 1 ? (
								<span class="badge bg-success w-100">✓</span>
							) : (
								<span class="badge bg-danger w-100">x</span>
							),
						mfa: (user) =>
							user.mfa_enabled ? (
								<span class="badge bg-success w-100">På</span>
							) : (
								<span class="badge bg-secondary w-100">Av</span>
							),
						resetMfa: (user) =>
							currentUser?.billable_admin && user.mfa_enabled && user.id !== currentUser.id ? (
								<button
									type="button"
									class="btn btn-sm btn-light"
									onClick={(e) => {
										e.stopPropagation();
										resetMfa(user);
									}}
									title="Återställ MFA"
								>
									<i class="fas fa-key" />
								</button>
							) : null,
					}}
				>
					<th>Namn</th>
					<th>E-Post</th>
					<th class="min">Administratör</th>
					<th class="min">MFA</th>
					<th class="min">Återställ MFA</th>
					<th class="min" />
				</Table>
			</Card>
			<div class="row">
				<Card
					buttons={{
						footer: [
							<Submit
								onSubmit={onSubmit}
								text="Skicka inbjudan"
								sending={loading}
							/>,
						],
					}}
				>
					<div class="row mb-3">
						<Input
							controls={{ register }}
							name="email"
							options={{ required: true }}
							label="E-Post"
							error={error}
						/>
					</div>
				</Card>
				<Card title="Inbjudningar" icon="fas fa-envelope">
					<Table
						rows={invites}
						keys={[
							'email',
							'created_at>date:short',
							`_this>button:remove:${icons.remove}`,
						]}
						functions={{
							remove: (invite) => removeInvite(invite),
						}}
					>
						<th>E-Post</th>
						<th>Skickad</th>
						<th class="min" />
					</Table>
				</Card>
			</div>
		</>
	);
}
